import * as React from 'react';
import {Dispatch} from "redux";
import {connect} from "react-redux";
import {Button, List, Icon, Popconfirm, Select, Row, Col} from "antd";

import {
    deleteBannerTemplateAsyncActions,
    fetchBannerTemplatesAsyncActions, IToggleBannerTemplatesFilterActionPayload, toggleBannerTemplatesFilterAction,
} from "../../store/banner/template/actions";
import {IBannerTemplate} from "../../store/banner/template/types";
import remergeCondition from "../../firebase/conditions";
import {AppState} from "../../store";
import {withAuthorization} from "../../firebase/withAuthorization";
import {Link, RouteComponentProps} from "react-router-dom";
import styles from './TemplateEditor.module.less'
import {AdminZone} from "../../components/AccessControl";
import {
    selectVisibleChildBannerTemplates,
    selectVisibleMasterBannerTemplates
} from "../../store/banner/template/selectors";
import BasicLayout from "../../layout/BasicLayout";

const {Option} = Select;

interface MatchParams {
    name: string;
}

interface IOwnProps extends RouteComponentProps<MatchParams> {
}

interface IStateProps {
    masterBannerTemplates: IBannerTemplate[],
    childBannerTemplates: IBannerTemplate[],
}

interface IDispatchProps {
    fetchBannerTemplates: () => void;
    deleteBannerTemplateById: (id: string) => void;
    toggleBannerTemplatesFilter?: (params: IToggleBannerTemplatesFilterActionPayload) => void;
}

type IProps = IOwnProps & IStateProps & IDispatchProps

const IconText = ({type, text, onClick}: { type: string, text: string, onClick: (event: any) => void }) => (
    <span onClick={onClick}>
        <Icon type={type} style={{marginRight: 8}}/>
        {text}
    </span>
);

class TemplateList extends React.Component<IProps> {
    constructor(props:IProps) {
        super(props)
        this.props.fetchBannerTemplates()
    }

    onDelete = (id: string) => {
        this.props.deleteBannerTemplateById(id)
    }

    toggleChildren = (parentId: string | undefined) => {
        if (this.props.toggleBannerTemplatesFilter) {
            this.props.toggleBannerTemplatesFilter({filter: {parentId: parentId}})
        }
    }

    render() {
        const header = <React.Fragment>
            <AdminZone>
                <Link to={"/templates/new"}>
                    <Button>New Template</Button>
                </Link>
            </AdminZone>
        </React.Fragment>
        return (
            <BasicLayout header={header}>
                <div className={styles.rootContainer}>
                    <Row gutter={24}>
                        <Col span={12}>
                            <List
                                itemLayout="horizontal"
                                size="large"
                                header={<h3>Master Templates</h3>}
                                dataSource={this.props.masterBannerTemplates}
                                renderItem={(item: IBannerTemplate) => (
                                    <List.Item
                                        key={item.name}
                                        actions={[
                                            <AdminZone key="delete-action">
                                                <Popconfirm
                                                    title={`Are you sure delete template "${item.name}"?`}
                                                    onConfirm={() => {
                                                        this.onDelete(item.id)
                                                    }}
                                                    okText="Yes"
                                                    cancelText="No"
                                                >
                                                    <IconText
                                                        type="delete"
                                                        text="Delete"
                                                        onClick={() => {
                                                        }}
                                                    />
                                                </Popconfirm>
                                            </AdminZone>
                                            ,
                                            <IconText
                                                type="show"
                                                text="Children Templates"
                                                onClick={() => {
                                                    this.toggleChildren(item.id)
                                                }}
                                            />
                                        ]}
                                    >
                                        <List.Item.Meta
                                            title={<Link to={"/templates/" + item.id}>{item.name}</Link>}
                                        />
                                    </List.Item>
                                )}
                            />
                        </Col>
                        <Col span={12}>
                            <List
                                itemLayout="horizontal"
                                size="large"
                                header={<h3>Children Templates</h3>}
                                dataSource={this.props.childBannerTemplates}
                                renderItem={(item: IBannerTemplate) => (
                                    <List.Item
                                        key={item.name}
                                        actions={[
                                            <AdminZone key="delete-action">
                                                <Popconfirm
                                                    title={`Are you sure delete template "${item.name}"?`}
                                                    onConfirm={() => {
                                                        this.onDelete(item.id)
                                                    }}
                                                    okText="Yes"
                                                    cancelText="No"
                                                >
                                                    <IconText
                                                        type="delete"
                                                        text="Delete"
                                                        onClick={() => {
                                                        }}
                                                    />
                                                </Popconfirm>
                                            </AdminZone>
                                        ]}
                                    >
                                        <List.Item.Meta
                                            title={<Link to={"/templates/" + item.id}>{item.name}</Link>}
                                        />
                                    </List.Item>
                                )}
                            />
                        </Col>
                    </Row>
                </div>
            </BasicLayout>
        )
    }
}

const authCondition = (authUser: any) => remergeCondition(authUser);

const mapStateToProps = (state: AppState, props: IOwnProps): IStateProps => ({
    masterBannerTemplates: selectVisibleMasterBannerTemplates(state),
    childBannerTemplates: selectVisibleChildBannerTemplates(state),
});

const mapDispatchToProps = (
    dispatch: Dispatch
): IDispatchProps => {
    return {
        fetchBannerTemplates: () => dispatch(fetchBannerTemplatesAsyncActions.request({})),
        deleteBannerTemplateById: (id: string) => dispatch(deleteBannerTemplateAsyncActions.request({id: id})),
        toggleBannerTemplatesFilter: (params: IToggleBannerTemplatesFilterActionPayload) => dispatch(toggleBannerTemplatesFilterAction(params)),
    };
};

export default withAuthorization(authCondition)(connect(
    mapStateToProps,
    mapDispatchToProps,
)(TemplateList));


